import React, { Component } from 'react'

import './DesignPage.css';
import Header from '../header/Header';
import DesignLanding from './designlanding/DesignLanding';
import Footer from '../footer/Footer';

export class DesignPage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {

    return (
      <div className="cars-container">
        <Header />
        <DesignLanding />
        <Footer />
      </div>
    )
  }
}

export default DesignPage
